import React from "react";
import { StyledTestimonialItemWrapper } from "./style";

const TestimonialsWrapper = ({ children }) => <StyledTestimonialItemWrapper>{children}</StyledTestimonialItemWrapper>;

export default TestimonialsWrapper;
